import { Container, Content, ImageLogo } from "./styles";

import Logo from "../../images/logo.svg";
import IconWhatsApp from "../../images/icons/whatsapp.svg";
import IconEmail from "../../images/icons/email.svg";

const Header = () => {
  return (
    <Container>
      <Content>
        <ImageLogo src={Logo} alt="logo" />

        <div>
          <a href="https://wa.me/5511994602852" target="_blank">
            <img src={IconWhatsApp} alt="whatsapp" />
            (11) 99460-2852
          </a>

          <a href="mailto: carlacassavia@cassaviaadvocacia.com.br">
            <img src={IconEmail} alt="email" />
            carlacassavia@cassaviaadvocacia.com.br
          </a>
        </div>
      </Content>
    </Container>
  );
};

export default Header;
